import { Injectable, Injector } from '@angular/core';
import { HookParserEntry } from 'ngx-dynamic-hooks';
import {
  BackwardComponent,
  BalloonsComponent,
  CounterComponent,
  DotConnectComponent,
  DraggableComponent,
  ForwardComponent,
  ImageZoomComponent,
  IntegerInputComponent,
  IntInputRegionComponent,
  KhManipGraphComponent,
  KhManipScorableComponent,
  KhManipScorableDraggable,
  KhManipScorableInput,
  KhManipScorableIntInput,
  KhManipulativeBackwardComponent,
  KhManipulativeClickableComponent,
  KhManipulativeClickableRegionComponent,
  KhManipulativeDropdown,
  KhManipulativeForwardComponent,
  KhManipulativeImage,
  KhManipulativePaneComponent,
  KhManipulativeText,
  KhManipulativeWindowComponent,
  KhManipulativeWindowControlsComponent,
  KhManipulativeWindowsComponent,
  KhManipWindowsComponent,
  KhSpriteComponent,
  KhWindowsCounter,
  ManipAddingblocksComponent,
  ManipAlgebraTilesComponent,
  ManipClickableComponent,
  ManipDraggableComponent,
  ManipEquivFractionsComponent,
  ManipFractionStripsComponent,
  ManipImageswapComponent,
  ManipMultiplyComponent,
  ManipSubtractingblocksComponent,
  ManipTextComponent,
  MaterialBridgeComponent,
  MinecartPuzzleComponent,
  NodeComponent,
  PaneComponent,
  PixiPuzzleLoader,
  PuzzleBaseComponent,
  PuzzleFactoryComponent,
  PuzzleOverlayComponent,
  PuzzleTemplateComponent,
  RegionComponent,
  RepresentingNumbersComponent,
  RollbotPuzzleComponent,
  SpotlightComponent,
  StringInputComponent,
  WindowComponent,
  WindowControlsComponent,
  WindowsService } from 'shared-components';

import { VideoComponent } from 'app/shared/components/video/video.component';
import { ManipulativeConfig } from '../models/manipulative-config.model';

@Injectable({
  providedIn: 'root'
})
export class ManipulativesService {
  public createDynamicHooks(hostComponentInjector: Injector): HookParserEntry[] {
    const questionInjector = Injector.create({ parent: hostComponentInjector, providers: [] });
    const componentTree: ManipulativeConfig[] = [
      { component: RegionComponent },
      { component: DraggableComponent },
      { component: IntInputRegionComponent },
      { component: ManipClickableComponent },
      { component: ManipDraggableComponent },
      { component: ManipEquivFractionsComponent },
      { component: ManipAlgebraTilesComponent },
      { component: ManipFractionStripsComponent },
      { component: ManipMultiplyComponent },
      { component: ManipImageswapComponent },
      { component: IntegerInputComponent },
      { component: ManipAddingblocksComponent },
      { component: ManipSubtractingblocksComponent },
      { component: ManipTextComponent },
      { component: PaneComponent },
      { component: ForwardComponent },
      { component: BackwardComponent },
      { component: DotConnectComponent },
      { component: NodeComponent },
      { component: ImageZoomComponent },
      { component: SpotlightComponent },
      { component: RepresentingNumbersComponent },
      { component: VideoComponent },
      { component: BalloonsComponent },
      { component: PuzzleOverlayComponent },
      { component: PuzzleBaseComponent },
      { component: PuzzleTemplateComponent },
      { component: RollbotPuzzleComponent },
      { component: MinecartPuzzleComponent },
      { component: MaterialBridgeComponent },
      { component: KhManipGraphComponent },
      { component: KhManipScorableComponent },
      { component: PuzzleFactoryComponent },
      { component: KhManipScorableInput },
      { component: KhManipScorableDraggable },
      { component: KhManipulativeImage },
      { component: KhManipulativeText },
      { component: KhManipulativeDropdown },
      { component: PixiPuzzleLoader },
      { component: KhManipScorableIntInput },
      { component: KhManipulativeClickableComponent },
      { component: KhManipulativeClickableRegionComponent },
      { component: KhWindowsCounter },
      {
        children: [
          { component: WindowComponent },
          { component: CounterComponent },
          { component: WindowControlsComponent },
          { component: StringInputComponent },
          { component: KhSpriteComponent }
        ],
        component: KhManipWindowsComponent,
        providers: [
          { provide: WindowsService }
        ]
      },
      { component: KhManipulativeWindowsComponent },
      { component: KhManipulativeWindowComponent },
      { component: KhManipulativeWindowControlsComponent },
      { component: KhManipulativeBackwardComponent },
      { component: KhManipulativeForwardComponent },
      { component: KhManipulativePaneComponent }
    ];
    let result: HookParserEntry[] = [];
    for (const config of componentTree) {
      result = result.concat(...this.createHookParserEntries(config, questionInjector));
    }

    return result;
  }

  private* createHookParserEntries(config: ManipulativeConfig, parentInjector: Injector): Generator<HookParserEntry, void, undefined> {
    const manipulativeInjector = Injector.create({ parent: parentInjector, providers: config.providers ?? [] });
    yield {
      component: config.component,
      injector: manipulativeInjector
    };
    if (config.children) {
      for (const child of config.children) {
        for (const result of this.createHookParserEntries(child, manipulativeInjector)) {
          yield result;
        }
      }
    }
  }
}
